
import BottomSheetContent from '../BottomSheetComponents/BottomSheetContent'

interface WhySwitchOnTrackBottomSheetProps {
    onDismiss: () => void
    ScreenName: string
}

export const WhySwitchOnTrackBottomSheet: React.FC<WhySwitchOnTrackBottomSheetProps> = ({
    onDismiss,
}) => {
    return (
        <BottomSheetContent
            bottomSheetHeadingClassName="!font-normal"
            heading="Why switch an On-track fund?"
            logoSrc="/images/power-rebalance/manual-book.png"
            onDismiss={onDismiss}
            bottomSheetBodyClassName="!px-0"
        >
            <div className='text-grey40 text-13 px-5'>
                <p className='text-sm'>We recommend upgrading an on-track fund only when its highly beneficial. </p>
                <br />
                <p className='text-sm'>This is to help you maximise your returns,
                    which is one of the key goals of your Power Rebalancing plan while keeping your risk the same. </p>
            </div>
        </BottomSheetContent>
    )
}
